<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "sellerChat"
};
</script>
<style lang="scss">
html,body {
  font-size: 12px;
  height: 100%;
}
#app {
  height: 100%;
  position: relative;
}
.filter-wrap {
  align-items: center;
  background: #eee;
  padding: 10px;
  z-index: 99;
  width: 20%;
  display: flex;
  width: 100%;
}
.scroll-nomore {
  line-height: 40px;
  text-align: center;
  color: #808695;
}
.ivu-layout-sider {
  background: #001529!important;
}
.ivu-menu-dark {
  background: #001529!important;
}
.spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
.ivu-spin-fix {
  background: none!important;
}
/* 预览图片 */
.pswp {
  z-index: 9999!important;
}
/*滚动动画隐藏*/
.ivu-scroll-content-loading {
  opacity: 1!important;
}
/*店铺授权过期*/
.store-expire-layer {
  background: rgba(64, 64, 64, 0.2);
  width: 88%;
  position: absolute;
  left: 200px;
  top: 0px;
  z-index: 999999;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #222;
  font-size: 16px;
}
.text-cut {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
